export default "/_next/static/images/unlimited-templates-33194b342663f9f665391548092d554e.png";